var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup573(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4987 69.1333L39.3033 55.4083H21.6941L30.4987 69.1333Z",
    fill: "#0D0C22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.25,
    fill: "#0D0C22",
    stroke: "#0D0C22",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 17C26.9197 17 23.486 18.4223 20.954 20.954C18.4223 23.486 17 26.9197 17 30.5C17 34.0803 18.4223 37.514 20.954 40.046C23.486 42.5777 26.9197 44 30.5 44C34.0803 44 37.514 42.5777 40.046 40.046C42.5777 37.514 44 34.0803 44 30.5C43.9951 26.9209 42.5713 23.4901 40.0407 20.9593C37.5099 18.4288 34.0791 17.0049 30.5 17ZM35.9846 36.8275C35.6582 37.1542 35.1288 37.1546 34.8018 36.8286L29.6562 31.6982V22.0621C29.6562 21.5961 30.034 21.2184 30.5 21.2184C30.966 21.2184 31.3438 21.5961 31.3438 22.0621V30.9885L35.9854 35.6452C36.3112 35.9721 36.3109 36.501 35.9846 36.8275Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup573);
export default __webpack_public_path__ + "static/media/Group 573.8a40e08f56f98b5ec95efbdb4abc4de8.svg";
export { ForwardRef as ReactComponent };